/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { VoiceAgentInferencerPolymorphic } from './VoiceAgentInferencerPolymorphic';
import {
  VoiceAgentInferencerPolymorphicFromJSON,
  VoiceAgentInferencerPolymorphicFromJSONTyped,
  VoiceAgentInferencerPolymorphicToJSON,
} from './VoiceAgentInferencerPolymorphic';
import type { VoiceAgentDataset } from './VoiceAgentDataset';
import {
  VoiceAgentDatasetFromJSON,
  VoiceAgentDatasetFromJSONTyped,
  VoiceAgentDatasetToJSON,
} from './VoiceAgentDataset';

/**
 *
 * @export
 * @interface VoiceAgentGenerationInputs
 */
export interface VoiceAgentGenerationInputs {
  /**
   *
   * @type {number}
   * @memberof VoiceAgentGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof VoiceAgentGenerationInputs
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentGenerationInputs
   */
  nSamples: number;
  /**
   *
   * @type {VoiceAgentDataset}
   * @memberof VoiceAgentGenerationInputs
   */
  readonly seedDataset: VoiceAgentDataset;
  /**
   *
   * @type {VoiceAgentInferencerPolymorphic}
   * @memberof VoiceAgentGenerationInputs
   */
  readonly inferencer: VoiceAgentInferencerPolymorphic;
}

/**
 * Check if a given object implements the VoiceAgentGenerationInputs interface.
 */
export function instanceOfVoiceAgentGenerationInputs(value: object): value is VoiceAgentGenerationInputs {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  return true;
}

export function VoiceAgentGenerationInputsFromJSON(json: any): VoiceAgentGenerationInputs {
  return VoiceAgentGenerationInputsFromJSONTyped(json, false);
}

export function VoiceAgentGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: VoiceAgentDatasetFromJSON(json['seed_dataset']),
    inferencer: VoiceAgentInferencerPolymorphicFromJSON(json['inferencer']),
  };
}

export function VoiceAgentGenerationInputsToJSON(
  value?: Omit<VoiceAgentGenerationInputs, 'id' | 'seedDataset' | 'inferencer'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
  };
}
